import * as authApi from '../../api/auth';
import { ApiError } from '../../api/client';
import { subscribePush } from '../../api/push';
import { route } from 'preact-router';
import {
  token,
  user,
  tenant,
  loading,
  error,
  success,
  visits,
  clients,
  tecnicos,
} from '../state';
import type { User as UserType, TenantSummary } from '../../api/types';
import { loadData } from './data.actions';

export async function login(email: string, password: string) {
  loading.value = true;
  error.value = null;
  try {
    const d = await authApi.login(email, password);
    setAuth(d.token, d.user, d.tenant);
  } catch (e) {
    error.value = (e as Error).message;
  } finally {
    loading.value = false;
  }
}

export async function register(
  empresa: string,
  slug: string,
  nombre: string,
  email: string,
  password: string
) {
  loading.value = true;
  error.value = null;
  try {
    const d = await authApi.register(empresa, slug, nombre, email, password);
    success.value = d.mensaje;
    route('/login', true);
  } catch (e) {
    error.value = (e as Error).message;
  } finally {
    loading.value = false;
  }
}

export function setAuth(t: string, u: UserType, te: TenantSummary | null) {
  token.value = t;
  user.value = u;
  tenant.value = te;
  localStorage.setItem('token', t);
  localStorage.setItem('user', JSON.stringify(u));
  localStorage.setItem('tenant', JSON.stringify(te));
  if (u.rol === 'superadmin') {
    route('/plataforma', true);
    return;
  }
  route(u.rol === 'admin' ? '/dashboard' : '/agenda', true);
  loadData();
  subscribePush();
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('tenant');
  token.value = null;
  user.value = null;
  tenant.value = null;
  visits.value = [];
  clients.value = [];
  tecnicos.value = [];
  error.value = null;
  success.value = null;
  document.body.classList.remove('admin-desktop');
  route('/login', true);
}

export { ApiError };
